<!-- Page banner Area -->
<div class="page-banner bg-2"></div>
<!-- End Page banner Area -->

<div class="container service-div">
  <div class="section-title">
    <span>Our Services</span>
    <h2>What we offer</h2>
  </div>
  <div class="one-service">
    <h4>1) Ocean Freight</h4>
    <p>
      We offer regular services for FCL, LCL as well as break bulk and Ro / Ro
      services to and from any major ports globally. Our international networks
      enable us to handle shipments directly from our terminal to terminal or
      even door to door. We offer door to door services combined with smooth
      customs clearance activity as either a forwarder or NVOCC operator. Our
      ocean services meets customer needs with cost effective, flexible
      services. Contract management ,vendor consolidation, purchase order
      management multi-model transportation, warehousing and distribution
      programs designed specifically to increase customer capabilities in global
      market.
    </p>
  </div>
  <div class="one-service">
    <h4>2) Less than Container Load</h4>
    <p>
      As a customer of Cargocare, you can expect service excellence from a truly
      global player. LCL as being a crucial part of a total Ocean Freight system
      dedicate substantial resources to system development and maintenance. The
      total yearly volumes handled globally exceed 100,000 cbms. We have
      in-house systems that provides efficient cargo flow with speed, accuracy
      and cost efficiency. Our strong network hold of national gateways
      prioritizes to serve all major markets with direct consolidation. Our goal
      is to carry over 97% of our total LCL volumes in-house and to our
      networking partner. Co-loading out with third party NVOCCs is always the
      last option. Working with reputable carriers, we create fast,
      cost-efficient and reliable LCL services that enhance our customers’
      competitiveness. All LCL services are accompanied by first-class Order
      Monitoring Systems and other tools for you to monitor cargo and
      information flow.
    </p>
  </div>
  <div class="one-service">
    <h4>3) Full Container Load (CFL)</h4>
    <p>
      Being one of the best ocean freight providers for FCL, we handle world
      wide destinations. Through centralized purchasing management, the total
      volumes are negotiated with first-class carriers to ensure quality, space
      allotment and optimum pricing. We strive for long term agreements with
      partner carriers that allow for direct EDI links, simplifying information
      and documentation flow. In major regions we handle the inter-modal
      transportation of FCL. All FCL services are accompanied by first-class
      Order Monitoring Systems and other tools for you to monitor cargo and
      information flow.
    </p>
  </div>
  <div class="one-service" id="sea">
    <h4>4) Sea/ Air Freight</h4>
    <p>
      The alternative to the speed of air freight and the low cost of ocean
      freight is a combination of both. Our customers can benefit from our
      outstanding strength in air and ocean freight, with the added advantage of
      real-time visibility at every step door-to-door.
    </p>
    <p><b>Customer Benefits:</b></p>
    <ul>
      <li>No weight or size restrictions (subject to aircraft)</li>
      <li>Defined transit time statement</li>
      <li>Firm quotation</li>
      <li>Tracking services</li>
      <li>Confirmed booking</li>
      <li>EDI connectivity</li>
    </ul>
  </div>
  <div class="one-service" id="break-bulk">
    <h4>5) Break Bulk</h4>
    <p>
      Break bulk shipping is still used more frequently than you might think,
      especially in fields that need to move large or heavy goods, such as the
      petrochemical, oil and gas, energy, marine, and mining industries. Types
      of goods that are commonly transported in a break bulk shipment include
      timber, steel slabs, paper pulp, heavy machinery, and project cargo (such
      as power generating equipment and refinery equipment).
    </p>
  </div>
  <div class="one-service">
    <h4>6) Custom Clearance/ Documentation</h4>
    <p>
      Overseas Air Cargo Services a division of Cargocare Logistics Pvt. Ltd.
      authorized Indian custom brokers, licensed by Indian customs authority to
      handle custom related matters in India. We have one stop shop for our
      clients custom needs.
    </p>
    <p><b>We assist our clients in custom clearances and documentation.</b></p>
    <ul>
      <li>Import/Export</li>
      <li>
        Team of highly trained professionals to handle custom related queries
      </li>
      <li>
        Custom clearance & door delivery in ICD’sPersonal customer relationships
      </li>
    </ul>
  </div>

  <div class="one-service" id="surface-transportation">
    <h4>7) Surface Transportation</h4>
    <p>
      Cargo care operates a Fleet of vehicle in India for delivery of
      consignment at the customer’s doorstep.
    </p>
    <p><b>Automotive Logistics</b></p>
    <p>
      Fleet of trucks and trailers for transportation in all over India to
      deliver the consignment in various shapes and sizes.
    </p>
    <p><b>General Cargo</b></p>
    <p>Provision of delivery van to move small size cargoes.</p>
    <p><b>Container Transportation</b></p>
    <p>
      Fleet of vehicles and container chassis available for smooth
      transportation of inbound and outbound cargoes.
    </p>
  </div>
  <div class="one-service">
    <h4>8) Logistics & Distribution</h4>
    <p>
      Our international network allows us to handle shipments directly from
      terminal to terminal or even from door to door. We will find alternative
      transport solutions such as conventional ships, ro/ro ships barges and
      lighters for goods that cannot be transported in containers. As is true
      for all the products, we offer full door to door services combined with
      smooth custom clearance operating either as a forwarder or NVOCC.
      Cargocare ocean services meet your needs with cost-effective flexible
      services. We make a difference with LCL / FCL, contract management, vendor
      consolidation, multi-modal transportation, warehousing and distribution
      programsand purchase order management designed to increase your capability
      in global markets.
    </p>
    <p>
      From single point to point delivery to sophisticated cross dock or just in
      time programs, Cargocare has the distribution expertise to give downstream
      logistics a competitive edge. LTL/FTL carriers provide a variety of
      distribution strategies that increase the speed of your supply chain and
      reduces your total cost. We can offer warehousing & distribution through
      out India.
    </p>
    <p>
      We define logistics as the management of goods, information and financial
      transactions to ensure the timely and cost effective flow of inventory
      from suppliers to end consumers on a global basis. For a long time
      Cargocare is meeting needs of importers and exporters with a comprehensive
      range of global transportation and logistics services. Strategic carriers
      relationship means your shipments large and small move with priority and
      attention from point of origin to final destination, bundling these core
      services with an internet accessible integrated information system
      pervious customers with valuable end to end visibility.
    </p>
  </div>
  <div class="one-service">
    <h4>9) Warehousing & Distribution</h4>
    <p>To procure warehouse to customers within and outside octroi limits.</p>
    <p>
      Management of goods, information and financial transactions to ensure
      timely and cost effective flow of inventory globally and in India.
    </p>
    <p>
      To provide valuable end to end visibility with an internet accessible
      integrated information systems.
    </p>
    <p>
      From single point to point delivery to sophisticated cross dock or just in
      time programs, we have the distribution expertise to give downstream
      logistics a competitive edge. Distribution strategies that increase speed
      of supply chain which reduces total cost.
    </p>
  </div>
</div>
